import { __assign } from "tslib";
import { useMMDispatchActions, useMMSelector } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getTierStreamId } from '../helpers';
import { getTiers } from '../selectors';
import { fetchMoreTiers } from '../actions';
var mapStateToProps = function (state) {
    var streamId = getTierStreamId();
    var tiers = getTiers(state);
    return {
        tiers: tiers,
        isFetchingTiers: selectors.isFetching(state, streamId),
        isTierStreamInitialized: selectors.isInitialized(state, streamId),
        hasMoreTiers: selectors.hasMore(state, streamId),
    };
};
export var useTiers = function () { return (__assign(__assign({}, useMMSelector(mapStateToProps)), useMMDispatchActions({ fetchMoreTiers: fetchMoreTiers }))); };
//# sourceMappingURL=withTiers.js.map